const NoUser = () => {
  return (
    <div className="flex items-center justify-center min-h-[60vh] px-4">
      <div className="text-center max-w-sm">
        <div className="mb-4">
          <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-gray-100">
            <span className="text-2xl">👤</span>
          </div>
        </div>

        <h2 className="text-xl font-semibold text-gray-800">
          No User Logged In
        </h2>

        <p className="text-gray-500 mt-2 text-sm">
          You need to be logged in to access this page.
        </p>

        <button
          onClick={() => (window.location.href = "/login")}
          className="mt-6 px-5 py-2 rounded-lg bg-blue-900 text-white text-sm font-medium hover:bg-blue-700 transition"
        >
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default NoUser;
